import { Badge, Group, Title } from '@mantine/core';

/**
 * アプリ名。
 *
 * MVP の段階であることを示す Beta を右上に添える。金額の管理を任せる道具なので、
 * まだ完成品ではないと分かる状態にしておく。
 *
 * バッジは見出しの上端に揃える（`align="flex-start"`）。行の中央に置くと、大きな
 * 見出しの横に並ぶ小さなラベルとして読まれ、上付きの注記に見えない。
 */
export function AppTitle({ order }: { order: 1 | 2 }): React.ReactElement {
  return (
    <Group gap={6} align="flex-start" wrap="nowrap">
      <Title order={order}>Chipless</Title>
      {/* Badge の既定は大文字化。「Beta」として読ませたいので打ち消す。 */}
      <Badge size="sm" variant="light" color="yellow" radius="sm" tt="none">
        Beta
      </Badge>
    </Group>
  );
}
